{
  "seo": {
    "title": "Learning Paths",
    "description": "Choose a goal-based path to guide your learning journey."
  },
  "title": "Learning Paths",
  "subtitle": "Pick a goal and follow a guided sequence of questions and activities.",
  "childFallback": "Child",
  "active": {
    "label": "Active Path",
    "progress": "{completed} of {total} steps completed",
    "continue": "Continue",
    "completedLabel": "Completed!"
  },
  "states": {
    "loading": "Loading learning paths...",
    "empty": "No learning paths available yet."
  },
  "history": {
    "title": "Completed paths",
    "completedBadge": "Completed"
  },
  "actions": {
    "viewDetails": "View details",
    "assignPath": "Assign path",
    "startPath": "Start path",
    "switchPath": "Switch to this path"
  }
}
